module.exports = __webpack_public_path__ + "static/img/ca.c976442e.svg";